import { Icon, type IconType } from '@/app/components/icons';
import {
  FOOTER_DATA_GA,
  FOOTER_DATA_TEST,
} from '@/app/components/layouts/footer/tracking';
import { Link } from '@/app/components/navigation/link';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
import { createDataGA } from '@/app/utils/createDataGA';
import { stripHtmlTags } from '@/app/utils/format';

export interface BuyingToolItemProps {
  icon: IconType;
  href: string;
  title: string;
  desc: string;
}

interface FooterBuyingToolsProps {
  items?: BuyingToolItemProps[];
}

export const FooterBuyingTools = ({ items = [] }: FooterBuyingToolsProps) => (
  <div
    {...createDataAttributes({
      test: FOOTER_DATA_TEST.buyingTools,
    })}
    className="grid grid-cols-5"
  >
    {items.map(({ href, icon, title, desc }, index) => (
      <Link
        key={index}
        {...createDataAttributes({
          test: FOOTER_DATA_TEST.buyingToolLink,
        })}
        {...createDataGA({
          click: true,
          eventName: FOOTER_DATA_GA.event,
          url: href,
          text: stripHtmlTags(title),
        })}
        href={href}
        className={cn(
          'transition-bg hover:bg-silver-100 border-y border-gray-50 px-1 py-3 text-center sm:p-3 lg:p-6 lg:text-left xl:p-8',
          {
            'border-l': index !== 0,
          }
        )}
      >
        <Icon
          size="md"
          icon={icon}
          className="mx-auto text-red-500 lg:mx-0 lg:size-8"
        />
        <h3
          className="font-noto-bold text-caption lg:text-body-2 mt-1.5 lg:mt-3"
          dangerouslySetInnerHTML={{ __html: title }}
        />
        <p
          className="text-body-2-fixed mt-1 hidden text-gray-700 lg:block"
          dangerouslySetInnerHTML={{ __html: desc }}
        />
      </Link>
    ))}
  </div>
);
